import { useLocalSearchParams } from 'expo-router';

import { SafetyReminder } from '@/screens/safety-reminder';

export default function SafetyReminderRoute() {
  const { otherUserId, connectionId } = useLocalSearchParams<{ otherUserId: string; connectionId?: string }>();
  return <SafetyReminder otherUserId={otherUserId} connectionId={connectionId} />;
}
